import { injectable } from "inversify";
import UserRepository from "../../../domain/repositories/UserRepository";
import { Either, right, left } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import UserEntity, { UserType } from "../../../domain/entities/UserEntity";
import Testing from "../../../presentation/utils/Testing";
import SearchResultEntity from "../../../domain/entities/SearchResultEntity";


const fakeUser: UserEntity = {
    id: "123",
    name: "Test User",
    role: UserType.ADMIN,
    document: "123456789",
    documentType: "CC",
    phone: "+1234567890",
    username: "testuser",
    prefix: "+57",
    email: "testuser@example.com",
}

@injectable()
class UserRepositoryFake implements UserRepository {
    searchUsersForShift = async (_:{query?: string, scheduleId: string, date: Date}): Promise<Either<ErrorEntity, UserEntity[]>> => {
        await Testing.sleeper(1000);
        return right([fakeUser, fakeUser, fakeUser]);
    }
    updateUser = async (_: {
        user: UserEntity,
        password?: string;
    }): Promise<Either<ErrorEntity, UserEntity>> => {
        await Testing.sleeper(1000);
        return right(_.user);
    }
    getUserById = async (id: string): Promise<Either<ErrorEntity, UserEntity>> => {
        await Testing.sleeper(1000);
        // return left({code: "notFound"});
        return right(fakeUser);
    }
    createUser = async (_: {
        user: UserEntity,
        password?: string;
    }): Promise<Either<ErrorEntity, UserEntity>> => {
        await Testing.sleeper(1000);
        return right(_.user);
    }
    searchUsers = async (_: {
        query?: string, page: number, itemsPerPage: number,
        role?: UserType
    }): Promise<Either<ErrorEntity, SearchResultEntity<UserEntity>>> => {
        await Testing.sleeper(1000);
        const limitOfPages = 3;
        if (_.page > limitOfPages) {
            return right({
                total: limitOfPages * _.itemsPerPage,
                data: [],
                itemsPerPage: _.itemsPerPage,
                page: _.page,
                pages: limitOfPages,
            });
        }
        const arrayOfFakes = Array.from({ length: _.page == limitOfPages ? _.itemsPerPage / 2 : _.itemsPerPage }, (_, i) => fakeUser);
        return right({
            total: (limitOfPages * _.itemsPerPage) - (_.itemsPerPage / 2),
            data: arrayOfFakes,
            itemsPerPage: _.itemsPerPage,
            page: _.page,
            pages: limitOfPages,
        });
    }
    deleteUser = async (id: string): Promise<Either<ErrorEntity, void>> => {
        await Testing.sleeper(1000);
        return right(undefined);
    }
}

export default UserRepositoryFake;